import React, { ChangeEvent } from 'react';
import { Field, isStringField } from '@truvity/widget__forms';
import { useFieldError, TextField } from '@truvity/widget__forms-mui-theme';

export const TextareaField = (props: Field<string | undefined>) => {
    const { input, typeDescriptor, meta } = props;

    if (!isStringField(typeDescriptor)) {
        throw new Error(`Incorrect descriptor type: ${input.name}`);
    }

    const error = useFieldError(meta);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const maxLength = typeDescriptor.ui.maxLength || event.target.value.length;

        input.onChange(event.target.value.slice(0, maxLength));
    };

    return (
        <TextField
            {...error}
            value={input.value}
            onChange={handleChange}
            meta={meta}
            typeDescriptor={typeDescriptor}
            MuiProps={{
                name: input.name,
                multiline: true,
                minRows: 5,
                onBlur: input.onBlur,
            }}
        />
    );
};
